import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import TabGridAndFormLayout from "../../../Components/ProForms/ProFormsLayout/TabGridAndFormLayout";
import ProGrid from "../../../Components/ProGrid/v2";
import NameCell from "../../../Components/ProGrid/components/NameCell";
import usePageState from "../../../../utils/customHooks/usePageState";
import { errorToast, successToast } from "../../../../utils/toastHelper";
import { Box, Alert, useTheme, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Tooltip } from "@mui/material";
import {
  GET_ALL_PROJECT_JOB,
  ADD_PROJECT_JOB,
  UPDATE_PROJECT_JOB,
  DELETE_PROJECT_JOB,
  GET_PROJECT_JOB,
  GET_ALL_JOB_TITLE,
  GET_ALL_ASSIGNRAPDROPDOWN,
  GET_ALL_ASSIGNRAPWAGESCALEDROPDOWN,
  GET_ALL_ASSIGNRAPJOBINFO,
  GET_PROJECTWISE_COUNTRYANDSTATE,
  GET_PWC_FILE_PATH,
  PROJECTS
} from "../../../../utils/services/apiPath";
import { deleteApi, postApi, getApi, putApi } from "../../../../utils/services";
import {
  changeMode,
  changeModeForField,
  checkEditEnabled,
  convertResponseDate,
  formatPayloadDate,
  prepareDefaultValues,
  prepareInitialConfig,
  projectJobsFormName,
  renderFormattedDate,
  stringToNumber
} from "../../../../utils/formHelper";
import { defaultDropdownConfig } from "../../../../utils/dropdownHelper";
import { projectsJobsPermissionSelector, subModPermissionSelector } from "../../../store/features/permissions/permissionsSlice";
import usePermission from "../../../../utils/customHooks/usePermission";
import { currencyColumnDef, dateColumnDef, percentageColumnDef } from "../../../Components/ProGrid/components/FormatCell";
import useColumn from "../../../../utils/customHooks/useColumns";
import { projectJobFormConfing, constructionType } from "../projectData";
import { BASE_WS_API_TOKEN, BASE_PWC_API_URL, STAUTES } from "../../../../utils/constant";
import "./ProjectJobs.scss";
import axios from "axios";
import ProjectJobsPwc from "./ProjectJobsPwc";
import ProButton from "../../../Components/ProButton";
import DialogModal from "../../../Components/DialogModel/index.js";
import { convertToCSV, downloadCSV } from "../../../../utils/csvExporter";
import { R_PROJECTS, R_PROJECTS_JOBS } from "../../../../utils/permissionReferenceConfig";
import { useFeatureFlagEnabled } from "posthog-js/react";
import ProToggleField from "../../../Components/Inputs/ToggleButton";
import WarningAmberOutlined from "@mui/icons-material/WarningAmberOutlined";
import dayjs from "dayjs";
import { createODataQuery } from "../../../../utils/services/oData";

export default function ProjectJobs() {
  const {
    currentPage,
    pageSize,
    data: jobData,
    rowCount,
    status,
    sortModel,
    searchString,
    setPageState,
    setPagination,
    setStatus,
    setSortModel,
    setSearchString
  } = usePageState();
  const { id } = useParams();
  const theme = useTheme();
  const isUnionLaborFeatureEnabled = useFeatureFlagEnabled("is_union_labor_fields_enabled");
  const isUnionOvertimeDoubletimeEnabled = useFeatureFlagEnabled("is_union_overtime_doubletime_enabled");

  const [showGrid, setShowGrid] = useState(true);
  const [projectJobData, setProjectJobData] = useState({});
  const [jobTitle, setJobTitle] = useState([]);
  const [jobTitleDescription, setJobTitleDescription] = useState({});
  const [assignRAPInfoGuids, setAssignRAPInfoGuids] = useState([]);
  const [assignRAPWageScaleGuids, setAssignRAPWageScaleGuids] = useState([]);
  const [wageRateConcented, setWageRateConcented] = useState(false);
  const [wsPayload, setWsPayload] = useState(null);
  const [jobSearchOptions, setJobSearchOptions] = useState([]);
  const [pauseUpdate, setPauseUpdate] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isFetchLabels, setIsFetchLabels] = useState(false);
  const [isFetchWsData, setIsFetchWsData] = useState(false);
  const [isNoRecordOnClassification, setIsNoRecordOnClassification] = useState(false);
  const [clrInfoMessage, setClrInfoMessage] = useState(null);
  const [isCountyState, setIsCountyState] = useState(false);
  const [apprenticeData, setApprenticeData] = useState([]);
  const [duplicateJobTitles, setDuplicateJobTitles] = useState({});
  const [isDuplicateJobTitles, setIsDuplicateJobTitles] = useState(false);
  const [isDeleteError, setIsDeleteError] = useState(false);
  const [deleteErrorMessage, setDeleteErrorMessage] = useState("");
  const [toggleStates, setToggleStates] = useState({});
  const [overrideErrors, setOverrideErrors] = useState({ ot: false, dt: false });
  const [pendingToggle, setPendingToggle] = useState(null);

  const [isOTWageOverridden, setIsOTWageOverridden] = useState(false);
  const [isOTFringeOverridden, setIsOTFringeOverridden] = useState(false);
  const [isDTWageOverridden, setIsDTWageOverridden] = useState(false);
  const [isDTFringeOverridden, setIsDTFringeOverridden] = useState(false);
  const [isUnionOTWageOverridden, setIsUnionOTWageOverridden] = useState(false);
  const [isUnionDTWageOverridden, setIsUnionDTWageOverridden] = useState(false);

  const [confirmLabourClassStatus, setConfirmLabourClassStatus] = useState({
    open: false,
    params: null,
    newStatus: null,
    labourClassification: "",
    statusText: ""
  });

  const ToggleCell = ({ params, toggleStates, handleStatusToggle }) => {
    const currentToggleState = params.row.isActive;

    const toggleForm = useForm({
      defaultValues: { isActive: currentToggleState }
    });

    useEffect(() => {
      toggleForm.setValue("isActive", currentToggleState);
    }, [currentToggleState, toggleForm]);

    return (
      <ProToggleField
        name="isActive"
        control={toggleForm.control}
        label=""
        rules={{}}
        mode="edit"
        permission={{
          canView: true,
          canEdit: true
        }}
        onChange={(event, newValue) => {
          toggleForm.setValue("isActive", currentToggleState);
          handleStatusToggle(params, newValue);
        }}
        size="small"
      />
    );
  };

  const handleStatusToggle = async (params, newStatus) => {
    const statusText = newStatus ? "Active" : "Inactive";

    setPendingToggle({
      projectJobTitleId: params.row.projectJobTitleId,
      newStatus: newStatus
    });
    setConfirmLabourClassStatus({
      open: true,
      params,
      newStatus,
      labourClassification: params.row.jobTitle,
      statusText
    });
  };

  const handleYesContinue = async () => {
    const { params, newStatus } = confirmLabourClassStatus;
    const jobTitleId = params?.id;
    try {
      if (newStatus) {
        const { error } = await putApi(`${PROJECTS}/${id}/jobTitles/${jobTitleId}/activate`);
        if (error) {
          errorToast(error);
          return;
        }
        getAllProjectJobTitles();
        successToast(`Labour Classification status updated to Active`);
      } else {
        onDelete(jobTitleId);
      }
    } catch (err) {
      errorToast("Failed to update Labour Classification status");
    } finally {
      setConfirmLabourClassStatus({ open: false, params: null, newStatus: null, labourClassification: "", statusText: "" });
    }
  };

  const handleNoCancel = () => {
    setConfirmLabourClassStatus({ open: false, params: null, newStatus: null, labourClassification: "", statusText: "" });
  };

  const [formConfig, setFormConfig] = useState(prepareInitialConfig(projectJobFormConfing));
  const { handleSubmit, control, setValue, getValues, watch, setError, clearErrors, trigger } = useForm({
    defaultValues: prepareDefaultValues(projectJobFormConfing)
  });
  const isEditModeOn = useMemo(() => checkEditEnabled(false, formConfig), [formConfig]);
  const { "Add Job Detail or Job Detail": addJobPermisison, "Job List": jobListPermission } = usePermission(
    projectsJobsPermissionSelector,
    projectJobsFormName
  );

  const prevailingStraightTimeFringe = watch("prevailingStraightTimeFringe");
  const prevailingStraightTimeWage = watch("prevailingStraightTimeWage");
  const prevailingOverTimeWage = watch("prevailingOverTimeWage");
  const prevailingOverTimeFringe = watch("prevailingOverTimeFringe");
  const prevailingDoubleTimeWage = watch("prevailingDoubleTimeWage");
  const prevailingDoubleTimeFringe = watch("prevailingDoubleTimeFringe");
  const unionStraightTimeWage = watch("unionStraightTimeWage");
  const unionStraightTimeFringe = watch("unionStraightTimeFringe");
  const unionStraightTimeFringeHealthAndWelfare = watch("unionStraightTimeFringeHealthAndWelfare");
  const unionStraightTimeFringePension = watch("unionStraightTimeFringePension");
  const unionStraightTimeFringeAnnuity = watch("unionStraightTimeFringeAnnuity");
  const unionStraightTimeFringeApprenticeTraining = watch("unionStraightTimeFringeApprenticeTraining");
  const unionStraightTimeFringeVacation = watch("unionStraightTimeFringeVacation");
  const unionStraightTimeFringeOther = watch("unionStraightTimeFringeOther");
  const unionOverTimeWage = watch("unionOverTimeWage");
  const unionOverTimeFringe = watch("unionOverTimeFringe");
  const unionOverTimeFringeHealthAndWelfare = watch("unionOverTimeFringeHealthAndWelfare");
  const unionOverTimeFringePension = watch("unionOverTimeFringePension");
  const unionOverTimeFringeAnnuity = watch("unionOverTimeFringeAnnuity");
  const unionOverTimeFringeApprenticeTraining = watch("unionOverTimeFringeApprenticeTraining");
  const unionOverTimeFringeVacation = watch("unionOverTimeFringeVacation");
  const unionOverTimeFringeOther = watch("unionOverTimeFringeOther");
  const hasOTFringeOverride = watch("hasOTFringeOverride");
  const unionDoubleTimeWage = watch("unionDoubleTimeWage");
  const unionDoubleTimeFringe = watch("unionDoubleTimeFringe");
  const unionDoubleTimeFringeHealthAndWelfare = watch("unionDoubleTimeFringeHealthAndWelfare");
  const unionDoubleTimeFringePension = watch("unionDoubleTimeFringePension");
  const unionDoubleTimeFringeAnnuity = watch("unionDoubleTimeFringeAnnuity");
  const unionDoubleTimeFringeApprenticeTraining = watch("unionDoubleTimeFringeApprenticeTraining");
  const unionDoubleTimeFringeVacation = watch("unionDoubleTimeFringeVacation");
  const unionDoubleTimeFringeOther = watch("unionDoubleTimeFringeOther");
  const hasDTFringeOverride = watch("hasDTFringeOverride");
  const isCraftTrade = watch("IsCraftTradeLaborPosition");
  const isAdminRole = watch("IsRole");
  const isExternalJobTitle = watch("isExternalJobTitle");
  const assignRAPInfoGuid = watch("assignRAPInfoGuid");
  const jobDescription = watch("jobDescription");
  const jobTitleId = watch("jobTitleId");
  const payTypePosition = watch("payTypePosition");

  // Calculated/read-only fields (totals + aggregated union fringe) are displayed by ReadOnlyInput,
  // which reads projectJobData (formValues), not the live RHF value. Mirror each computed value into
  // both so read mode stays current instead of only updating once the field is clicked into edit mode.
  const setCalculatedValue = (field, value) => {
    setValue(field, value);
    setProjectJobData(prev => ({ ...prev, [field]: value }));
  };

  const resetForm = () => {
    setProjectJobData({});
    setShowGrid(true);
    setFormConfig(changeMode("read"));
    setPauseUpdate(false);
    setOverrideErrors({ ot: false, dt: false });
  };

  const onCancel = () => {
    clearErrors(["IsCraftTradeLaborPosition"]);
    setOverrideErrors({ ot: false, dt: false });
    if (projectJobData?.projectJobTitleId) setFormConfig(changeMode("read"));
    else resetForm();
  };

  const onJobTitleClick = params => {
    setShowGrid(false);
    setPauseUpdate(true);
    setOverrideErrors({ ot: false, dt: false });
    getProjectJobData(params.id);
  };

  const addButtonAction = () => {
    if (!isFetchWsData) {
      Object.keys(formConfig)?.forEach(field => setValue(field, null));
      setProjectJobData({});
      setOverrideErrors({ ot: false, dt: false });
      onEdit();
      setShowGrid(false);
      setIsNoRecordOnClassification(false);
      setClrInfoMessage("");

      setIsOTWageOverridden(false);
      setIsOTFringeOverridden(false);
      setIsDTWageOverridden(false);
      setIsDTFringeOverridden(false);
      setIsUnionOTWageOverridden(false);
      setIsUnionDTWageOverridden(false);
    }
  };

  const closeCrlEmailModel = () => {
    getAllProjectJobTitles();
    setShowGrid(true);
  };

  const onSave = async data => {
    if (data.isApprenticeable && !data.assignRAPInfoGuid) {
      errorToast("RAP is required when Apprenticeship Eligible!");
      setError("assignRAPInfoGuid", { type: "manual", message: "RAP is required when Apprenticeship Eligible!" });
      return;
    }

    const isExternal = data.isExternalJobTitle;
    if (isExternal) {
      if (!data.externalJobTitle) {
        errorToast("External Job Title field is required.");
        return;
      }
    } else {
      if (!data.jobTitleId) {
        errorToast("Job Title field is required.");
        return;
      }
    }

    if (!data.laborClassificationType) {
      errorToast("Labor Classification Type is required");
      return;
    }

    // A wage is missing when it is empty, non-numeric, or not greater than 0. Uses stringToNumber so
    // non-numeric input (e.g. "abc") is caught here rather than slipping through as null on submit.
    const isMissingWage = v => {
      const n = stringToNumber(v);
      return n === null || n <= 0;
    };

    if (isUnionLaborFeatureEnabled && data.isUnion) {
      clearErrors(["unionStraightTimeWage"]);
      if (isMissingWage(data.unionStraightTimeWage)) {
        errorToast("Union Wage Rate is required and must be greater than 0 when Union Labor is enabled.");
        setError("unionStraightTimeWage", { type: "manual", message: "Union Wage Rate must be greater than 0." });
        return;
      }
    }

    if (isUnionLaborFeatureEnabled && isUnionOvertimeDoubletimeEnabled && data.isUnion) {
      clearErrors(["unionOverTimeWage", "unionDoubleTimeWage"]);
      if (isMissingWage(data.unionOverTimeWage)) {
        errorToast("Overtime Wage Rate is required and must be greater than 0 when Union Labor is enabled.");
        setError("unionOverTimeWage", { type: "manual", message: "Overtime Wage Rate must be greater than 0." });
        return;
      }
      if (isMissingWage(data.unionDoubleTimeWage)) {
        errorToast("Double-time Wage Rate is required and must be greater than 0 when Union Labor is enabled.");
        setError("unionDoubleTimeWage", { type: "manual", message: "Double-time Wage Rate must be greater than 0." });
        return;
      }
    }

    await submitJobSave(data);
  };

  const [finalApprenticeData, setFinalApprenticeData] = useState([]);

  const submitJobSave = async data => {
    if (isUnionLaborFeatureEnabled && data.isUnion) {
      const invalidFringeCategories = getInvalidFringeCategories(data);
      if (invalidFringeCategories.length) {
        errorToast(`Fringe category values cannot be negative: ${invalidFringeCategories.join(", ")}.`);
        return;
      }
    }

    // Normalize empty string values to null for overtime/doubletime fringe overrides
    const overtimeFringeKeys = [
      "unionOverTimeFringeHealthAndWelfare",
      "unionOverTimeFringePension",
      "unionOverTimeFringeAnnuity",
      "unionOverTimeFringeApprenticeTraining",
      "unionOverTimeFringeVacation",
      "unionOverTimeFringeOther"
    ];
    const doubletimeFringeKeys = [
      "unionDoubleTimeFringeHealthAndWelfare",
      "unionDoubleTimeFringePension",
      "unionDoubleTimeFringeAnnuity",
      "unionDoubleTimeFringeApprenticeTraining",
      "unionDoubleTimeFringeVacation",
      "unionDoubleTimeFringeOther"
    ];
    [...overtimeFringeKeys, ...doubletimeFringeKeys].forEach(key => {
      if (data[key] === "") data[key] = null;
    });
    const hasPositiveOverride = keys =>
      keys.some(key => {
        const val = data[key];
        if (val === null || val === undefined || val === "") return false;
        return parseFloat(val) > 0;
      });

    const otInvalid = !!isUnionLaborFeatureEnabled && !!data.isUnion && !!data.hasOTFringeOverride && !hasPositiveOverride(overtimeFringeKeys);
    const dtInvalid = !!isUnionLaborFeatureEnabled && !!data.isUnion && !!data.hasDTFringeOverride && !hasPositiveOverride(doubletimeFringeKeys);

    if (otInvalid || dtInvalid) {
      setOverrideErrors({ ot: otInvalid, dt: dtInvalid });
      if (dtInvalid) {
        errorToast("The Double-time override is turned on. Select at least one fringe and enter an amount, or turn off the override to save");
      } else {
        errorToast("The Overtime override is turned on. Select at least one fringe and enter an amount, or turn off the override to save");
      }
      return;
    }
    setOverrideErrors({ ot: false, dt: false });

    if (isCraftTrade && payTypePosition && !["Hourly", "Salary"].includes(payTypePosition)) {
      setError("IsCraftTradeLaborPosition", {
        type: "manual",
        message: "Craft/Trade Labor/Working Supervisor position cannot have a salaried pay type. Please select hourly"
      });
      return;
    }

    const hasAnyFringeValue = [
      unionStraightTimeFringeHealthAndWelfare,
      unionStraightTimeFringePension,
      unionStraightTimeFringeAnnuity,
      unionStraightTimeFringeApprenticeTraining,
      unionStraightTimeFringeVacation,
      unionStraightTimeFringeOther
    ].some(val => parseFloat(val || 0) > 0);

    if (isUnionLaborFeatureEnabled && data.isUnion && hasAnyFringeValue && parseFloat(unionStraightTimeFringe) !== getUnionFringeTotal()) {
      setError("unionStraightTimeFringe", {
        type: "manual",
        message: "Union Fringe must equal the total of all Fringe Dollar Amount subcategories."
      });
      return;
    }

    if (isSaving) return;
    setIsSaving(true);

    const payload = buildJobPayload(data, finalApprenticeData);
    const isAddMode = !projectJobData?.projectJobTitleId;
    const response = isAddMode
      ? await postApi(ADD_PROJECT_JOB(id), payload)
      : await putApi(UPDATE_PROJECT_JOB(id, projectJobData.projectJobTitleId), payload);
    setIsSaving(false);
    if (response?.error) {
      return errorToast(response.error);
    }
    const jobInfo = response;
    getAllProjectJobTitles();
    setFormConfig(changeMode("read"));
    successToast(`Labor Classification Detail ${isAddMode ? "Added" : "Updated"} Successfully`);
    const jobTitleId = projectJobData?.projectJobTitleId || jobInfo?.projectJobTitleId;
    if (jobTitleId) getProjectJobData(jobTitleId);
    else setShowGrid(true);
  };

  // Maps the flat prevailing-wage form fields to the PrevailingWageRate request object.
  // All six values are required and validated on the form (rules.required in projectData.js,
  // enforced through handleSubmit) — they are sent exactly as entered and never defaulted to 0.
  const mapPrevailingWageRate = data => ({
    straightTimeWage: stringToNumber(data?.prevailingStraightTimeWage),
    straightTimeFringe: stringToNumber(data?.prevailingStraightTimeFringe),
    overTimeWage: stringToNumber(data?.prevailingOverTimeWage),
    overTimeFringe: stringToNumber(data?.prevailingOverTimeFringe),
    doubleTimeWage: stringToNumber(data?.prevailingDoubleTimeWage),
    doubleTimeFringe: stringToNumber(data?.prevailingDoubleTimeFringe)
  });

  // Maps the flat union-wage form fields to the UnionWageRate request object (union job titles only).
  const mapUnionWageRate = data => ({
    straightTimeWage: stringToNumber(data?.unionStraightTimeWage),
    overTimeWage: stringToNumber(data?.unionOverTimeWage),
    doubleTimeWage: stringToNumber(data?.unionDoubleTimeWage),
    straightTimeFringeHealthAndWelfare: stringToNumber(data?.unionStraightTimeFringeHealthAndWelfare),
    straightTimeFringePension: stringToNumber(data?.unionStraightTimeFringePension),
    straightTimeFringeAnnuity: stringToNumber(data?.unionStraightTimeFringeAnnuity),
    straightTimeFringeApprenticeTraining: stringToNumber(data?.unionStraightTimeFringeApprenticeTraining),
    straightTimeFringeVacation: stringToNumber(data?.unionStraightTimeFringeVacation),
    straightTimeFringeOther: stringToNumber(data?.unionStraightTimeFringeOther),
    overTimeFringeHealthAndWelfare: stringToNumber(data?.unionOverTimeFringeHealthAndWelfare),
    overTimeFringePension: stringToNumber(data?.unionOverTimeFringePension),
    overTimeFringeAnnuity: stringToNumber(data?.unionOverTimeFringeAnnuity),
    overTimeFringeApprenticeTraining: stringToNumber(data?.unionOverTimeFringeApprenticeTraining),
    overTimeFringeVacation: stringToNumber(data?.unionOverTimeFringeVacation),
    overTimeFringeOther: stringToNumber(data?.unionOverTimeFringeOther),
    doubleTimeFringeHealthAndWelfare: stringToNumber(data?.unionDoubleTimeFringeHealthAndWelfare),
    doubleTimeFringePension: stringToNumber(data?.unionDoubleTimeFringePension),
    doubleTimeFringeAnnuity: stringToNumber(data?.unionDoubleTimeFringeAnnuity),
    doubleTimeFringeApprenticeTraining: stringToNumber(data?.unionDoubleTimeFringeApprenticeTraining),
    doubleTimeFringeVacation: stringToNumber(data?.unionDoubleTimeFringeVacation),
    doubleTimeFringeOther: stringToNumber(data?.unionDoubleTimeFringeOther),
    hasOTFringeOverride: !!data?.hasOTFringeOverride,
    hasDTFringeOverride: !!data?.hasDTFringeOverride,
    effectiveDateEnd: formatPayloadDate(data?.unionEffectiveDateEnd)
  });

  // Maps the labor-classification form values to the ProjectJobTitle request DTO. Only DTO fields are
  // emitted — the form's UI-only fields and the legacy flat wage keys are intentionally not sent.
  const buildJobPayload = (data, apprenticeData) => ({
    projectId: id,
    jobTitleId: data?.isExternalJobTitle ? null : data?.jobTitleId,
    startDate: data?.startDate,
    completeDate: data?.completeDate,
    jobDescription: data?.jobDescription,
    numberOfPositions: data?.numberOfPositions === "" ? null : data?.numberOfPositions,
    isInternalOrClient: data?.isInternalOrClient,
    isPwJobTitle: data?.isPwJobTitle,
    pwTitle: data?.pwTitle,
    state: data?.state,
    county: data?.county,
    perDiem: data?.perDiem || 0,
    onetCode: data?.onetCode,
    marketRate: data?.marketRate,
    compliant: "Yes",
    pwAiConfidenceMatchScore: data?.pwAiConfidenceMatchScore,
    titleMatch: data?.titleMatch,
    journeyWorkersWage: data?.journeyWorkersWage,
    externalJobTitle: data?.externalJobTitle,
    isCraftOrTradeLabor: data?.IsCraftTradeLaborPosition,
    isAdministrativeRole: data?.IsRole,
    isExternalJobTitle: data?.isExternalJobTitle,
    payTypePosition: data?.payTypePosition,
    salaryAmount: data?.salaryAmount,
    isApprenticeable: data?.isApprenticeable,
    assignRAPInfoGuid: data?.assignRAPInfoGuid || null,
    assignRAPWageScaleGuid: data?.assignRAPWageScaleGuid || null,
    wageRateConsented: wageRateConcented,
    isOperator: data?.isOperator,
    isResponsibleForUpkeep: data?.isResponsibleForUpkeep,
    typeOfOperator: data?.typeOfOperator,
    typeOfEquipment: getJobTitleComma(data?.typeOfEquipment || []),
    typeOfJob: getJobTitleComma(data?.typeOfJob || []),
    footNotesModel: data?.footNotesModel,
    footnoteSickDays: data?.footnoteSickDays,
    footnoteVacationDays: data?.footnoteVacationDays,
    footnoteHolidays: data?.footnoteHolidays,
    footnoteOthers: data?.footnoteOthers,
    samFileName: data?.samFileName,
    generalDecisionNumber: data?.generalDecisionNumber,
    samFilePath: data?.samFilePath,
    jobInternalId: data?.jobInternalId,
    groupClassification: data?.groupClassification,
    zone: data?.zone,
    equipmentUsed: data?.equipmentUsed,
    isUnion: data?.isUnion,
    isCustomApprenticeOnboardingRequired: data?.isCustomApprenticeOnboardingRequired,
    customApprenticeOnboardings: apprenticeData || [],
    isCLRInitiated: data?.isCLRInitiated,
    conformanceLabourRequest: data?.conformanceLabourRequest,
    prevailingWageRate: mapPrevailingWageRate(data),
    unionWageRate: data?.isUnion ? mapUnionWageRate(data) : null
  });

  const onSaveClr = async data => {
    const payload = buildJobPayload(data, data?.customApprenticeOnboardings);
    const isAddMode = !projectJobData?.projectJobTitleId;
    const response = isAddMode
      ? await postApi(ADD_PROJECT_JOB(id), payload)
      : await putApi(UPDATE_PROJECT_JOB(id, projectJobData.projectJobTitleId), payload);
    if (response?.error) return errorToast(response.error);
  };

  const getTypeOfEquipment = projectJob => {
    if (projectJob?.typeOfEquipment) {
      if (projectJob.typeOfEquipment.includes(",")) {
        return projectJob.typeOfEquipment.split(",");
      } else {
        return [projectJob.typeOfEquipment];
      }
    }
    return [];
  };

  const getTypeOfJob = projectJob => {
    if (projectJob?.typeOfJob) {
      if (projectJob.typeOfJob.includes(",")) {
        return projectJob.typeOfJob.split(",");
      } else {
        return [projectJob.typeOfJob];
      }
    }
    return [];
  };

  const getProjectJobData = async projectJobTitleId => {
    if (projectJobTitleId) {
      const response = await getApi(GET_PROJECT_JOB(id, projectJobTitleId));
      if (response?.error) {
        errorToast(response.error);
        return;
      }
      const projectJob = response;
      if (projectJob) {
        // RAP wage-scale / job-info fetches are triggered by the useEffect
        // watching assignRAPInfoGuid (set below via setValue) — calling them
        // here as well would double-fire both requests on load.
        // New two-table wage model: flatten the nested objects back onto the flat form fields the
        // form binds to. Aggregate union fringe = total − wage (= sum of the breakdown).
        const pw = projectJob.prevailingWageRate || {};
        const uw = projectJob.unionWageRate || {};
        const round2 = n => (n == null ? null : Number(Number(n).toFixed(2)));
        const fringeFromTotal = (total, wage) => (total == null ? null : round2(Number(total) - Number(wage || 0)));
        let data = {
          ...projectJob,
          // Prevailing wage (ST/OT/DT). The legacy PW baseline + owner-approved + state values all
          // collapsed into this single prevailing value (two-table model).
          prevailingStraightTimeWage: pw.straightTimeWage,
          prevailingStraightTimeFringe: pw.straightTimeFringe,
          prevailingStraightTimeTotalHourlyComp: pw.straightTimeTotalHourlyComp,
          prevailingOverTimeWage: pw.overTimeWage,
          prevailingOverTimeFringe: pw.overTimeFringe,
          prevailingOverTimeTotalHourlyComp: pw.overTimeTotalHourlyComp,
          prevailingDoubleTimeWage: pw.doubleTimeWage,
          prevailingDoubleTimeFringe: pw.doubleTimeFringe,
          prevailingDoubleTimeTotalHourlyComp: pw.doubleTimeTotalHourlyComp,
          // Union wage + fringe breakdown (ST/OT/DT)
          unionStraightTimeWage: uw.straightTimeWage,
          unionStraightTimeFringe: fringeFromTotal(uw.straightTimeTotalHourlyComp, uw.straightTimeWage),
          unionStraightTimeTotalHourlyComp: uw.straightTimeTotalHourlyComp,
          unionStraightTimeFringeHealthAndWelfare: uw.straightTimeFringeHealthAndWelfare,
          unionStraightTimeFringePension: uw.straightTimeFringePension,
          unionStraightTimeFringeAnnuity: uw.straightTimeFringeAnnuity,
          unionStraightTimeFringeApprenticeTraining: uw.straightTimeFringeApprenticeTraining,
          unionStraightTimeFringeVacation: uw.straightTimeFringeVacation,
          unionStraightTimeFringeOther: uw.straightTimeFringeOther,
          unionOverTimeWage: uw.overTimeWage,
          unionOverTimeFringe: fringeFromTotal(uw.overTimeTotalHourlyComp, uw.overTimeWage),
          unionOverTimeTotalHourlyComp: uw.overTimeTotalHourlyComp,
          unionDoubleTimeWage: uw.doubleTimeWage,
          unionDoubleTimeFringe: fringeFromTotal(uw.doubleTimeTotalHourlyComp, uw.doubleTimeWage),
          unionDoubleTimeTotalHourlyComp: uw.doubleTimeTotalHourlyComp,
          unionOverTimeFringeHealthAndWelfare: uw.overTimeFringeHealthAndWelfare,
          unionOverTimeFringePension: uw.overTimeFringePension,
          unionOverTimeFringeAnnuity: uw.overTimeFringeAnnuity,
          unionOverTimeFringeApprenticeTraining: uw.overTimeFringeApprenticeTraining,
          unionOverTimeFringeVacation: uw.overTimeFringeVacation,
          unionOverTimeFringeOther: uw.overTimeFringeOther,
          unionDoubleTimeFringeHealthAndWelfare: uw.doubleTimeFringeHealthAndWelfare,
          unionDoubleTimeFringePension: uw.doubleTimeFringePension,
          unionDoubleTimeFringeAnnuity: uw.doubleTimeFringeAnnuity,
          unionDoubleTimeFringeApprenticeTraining: uw.doubleTimeFringeApprenticeTraining,
          unionDoubleTimeFringeVacation: uw.doubleTimeFringeVacation,
          unionDoubleTimeFringeOther: uw.doubleTimeFringeOther,
          hasOTFringeOverride: uw.hasOTFringeOverride,
          hasDTFringeOverride: uw.hasDTFringeOverride,
          projectId: id,
          projectJobTitleId: projectJobTitleId,
          jobTitleId: projectJob.jobTitleDropdown?.value,
          IsCraftTradeLaborPosition: projectJob.isCraftOrTradeLabor,
          IsRole: projectJob.isAdministrativeRole,
          laborClassificationType: projectJob.isCraftOrTradeLabor ? "craft" : projectJob.isAdministrativeRole ? "admin" : null,
          assignRAPInfoGuid: projectJob?.assignRapInfoDropdown?.value || null,
          assignRAPWageScaleGuid: projectJob?.assignRapWageScaleDropdown?.value || null,
          isApprenticeable: projectJob.isApprenticeable || false,
          typeOfEquipment: getTypeOfEquipment(projectJob),
          typeOfJob: getTypeOfJob(projectJob),
          unionEffectiveDateEnd: convertResponseDate(uw.effectiveDateEnd),

          ...(projectJob?.assignRapInfoGuid ? { assignRAPInfoGuid: projectJob.assignRapInfoGuid } : {}),
          ...(projectJob?.assignRapWageScaleGuid ? { assignRAPWageScaleGuid: projectJob.assignRapWageScaleGuid } : {})
        };

        setProjectJobData(data);

        const expectedOTWage = Number(data.prevailingStraightTimeWage || 0) * 1.5;
        const expectedDTWage = Number(data.prevailingStraightTimeWage || 0) * 2;
        setIsOTWageOverridden(Number(data.prevailingOverTimeWage || 0) !== Number(expectedOTWage.toFixed(2)));
        setIsDTWageOverridden(Number(data.prevailingDoubleTimeWage || 0) !== Number(expectedDTWage.toFixed(2)));
        setIsOTFringeOverridden(Number(data.prevailingOverTimeFringe || 0) !== Number(data.prevailingStraightTimeFringe || 0));
        setIsDTFringeOverridden(Number(data.prevailingDoubleTimeFringe || 0) !== Number(data.prevailingStraightTimeFringe || 0));
        const expectedUnionOTWage = Number(data.unionStraightTimeWage || 0) * 1.5;
        const expectedUnionDTWage = Number(data.unionStraightTimeWage || 0) * 2;
        setIsUnionOTWageOverridden(Number(data.unionOverTimeWage || 0) !== Number(expectedUnionOTWage.toFixed(2)));
        setIsUnionDTWageOverridden(Number(data.unionDoubleTimeWage || 0) !== Number(expectedUnionDTWage.toFixed(2)));

        Object.keys(formConfig)?.forEach(field => {
          if (field === "isApprenticeable") {
            setValue(field, projectJob.isApprenticeable === true);
          } else {
            setValue(field, data[field]);
          }
        });
      }
    }
  };

  const handleDownloadCSV = useCallback(async () => {
    try {
      const activeSort = sortModel?.[0] || { field: "jobTitle", sort: "asc" };
      const query = createODataQuery(
        ["jobTitle", "externalJobTitle", "onetCode", "typeOfEquipment"],
        [],
        "",
        searchString,
        [activeSort],
        rowCount || 10000,
        0
      );

      const { data: apiData, error } = await getApi(`${GET_ALL_PROJECT_JOB}${query}&projectId=${id}`);

      if (error) return errorToast("Download failed.");

      const data = Array.isArray(apiData) ? apiData : apiData?.data || [];

      if (error) return errorToast("Download failed.");
      if (!Array.isArray(data) || !data.length) return errorToast("No data to export.");

      const money = v => (v != null ? `$${Number(v).toFixed(2)}` : "N/A");
      const exportData = data.map(item => {
        // Wage data now arrives as nested prevailingWageRate / unionWageRate objects (two-table model).
        const pw = item.prevailingWageRate || {};
        const uw = item.unionWageRate || {};
        const unionStraightTimeFringe =
          uw.straightTimeTotalHourlyComp != null ? Number(uw.straightTimeTotalHourlyComp) - Number(uw.straightTimeWage || 0) : null;
        return {
          "Labor Classification Title": item.isExternalJobTitle ? item.externalJobTitle : item.jobTitle,
          "ONET Code": item.onetCode || "N/A",
          "Number Of Positions": item.numberOfPositions ?? 0,
          "Prevailing Wage Rate": money(pw.straightTimeWage),
          "Prevailing Fringe": money(pw.straightTimeFringe),
          "Prevailing Total Hourly Comp": money(pw.straightTimeTotalHourlyComp),

          ...(isUnionLaborFeatureEnabled
            ? {
                "Union Wage Rate": money(uw.straightTimeWage),
                "Union Fringe": money(unionStraightTimeFringe),
                "Union Wage Rate Expiration Date": renderFormattedDate(uw.effectiveDateEnd) || "N/A",
                "Total Union Hourly Comp": money(uw.straightTimeTotalHourlyComp)
              }
            : {}),

          "PW AI % Confidence Match Score": item.pwAiConfidenceMatchScore != null ? `${item.pwAiConfidenceMatchScore.toFixed(2)}%` : "N/A"
        };
      });

      const csv = convertToCSV(exportData);
      downloadCSV(csv, "ProjectJobs.csv");
    } catch (err) {
      console.error("CSV Export Error:", err);
      errorToast("Unexpected error during export.");
    }
  }, [id, rowCount, searchString, sortModel]);

  const getPWCFilePath = async s3Url => {
    if (s3Url) {
      const data = await getApi(`${GET_PWC_FILE_PATH}?path=${s3Url}`);
      if (data?.data) {
        window.open(data.data, "_blank");
      }
    }
  };

  const onDelete = async params => {
    const { error } = await deleteApi(DELETE_PROJECT_JOB(id, params));
    if (error) {
      setDeleteErrorMessage(error);
      setIsDeleteError(true);
    } else {
      getAllProjectJobTitles();
      setShowGrid(true);
      successToast(`Labour Classification status updated to Inactive`);
    }
  };

  const getJobTitleComma = jobTitleList => {
    let stringJob = "";
    jobTitleList?.map((job, index) => {
      if (index === 0) stringJob = job;
      else stringJob = `${stringJob}, ${job}`;
    });
    return stringJob;
  };

  const { "Add Job Detail or Job Detail": projectJobsPermission } = usePermission(subModPermissionSelector(R_PROJECTS, R_PROJECTS_JOBS), [
    "Projects",
    "Jobs",
    "Add Job Detail or Job Detail"
  ]);

  const columns = useColumn(
    [
      {
        field: "jobTitle",
        headerName: "Company Job Title",
        renderCell: params => {
          const title = params.row.isExternalJobTitle ? params.row.externalJobTitle : params.row.jobTitle;

          const showWarning = params.row.isApprenticeable === true && (params.row.hasApprentice !== true || params.row.hasMentor !== true);

          return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {showWarning && (
                <Tooltip title="This RAP is missing a mentor for this labor classification. Add one to complete setup.">
                  <WarningAmberOutlined sx={{ fontSize: 18, color: "#f5a623" }} />
                </Tooltip>
              )}
              <NameCell params={params} onClick={onJobTitleClick}>
                {" "}
                {title}{" "}
              </NameCell>
            </Box>
          );
        }
      },
      {
        field: "isActive",
        headerName: "Active",
        width: 120,
        renderCell: params => <ToggleCell params={params} toggleStates={toggleStates} handleStatusToggle={handleStatusToggle} />
      },
      {
        field: "onetCode",
        headerName: "ONET Code",
        renderCell: params => <Box>{params.row.onetCode || "N/A"}</Box>
      },
      {
        field: "numberOfPositions",
        headerName: "Number Of Positions"
      },
      // Wage data is served as nested prevailingWageRate / unionWageRate complex objects. valueGetter
      // reads the nested leaf; sortable:false avoids emitting an OData $orderby on a non-flat path.
      currencyColumnDef({
        field: "prevailingStraightTimeWage",
        headerName: "Prevailing Wage Rate",
        sortable: false,
        valueGetter: params => params.row.prevailingWageRate?.straightTimeWage ?? null
      }),
      currencyColumnDef({
        field: "prevailingStraightTimeFringe",
        headerName: "Prevailing Fringe",
        sortable: false,
        valueGetter: params => params.row.prevailingWageRate?.straightTimeFringe ?? null
      }),
      currencyColumnDef({
        field: "prevailingStraightTimeTotalHourlyComp",
        headerName: "Prevailing Total Hourly Comp",
        sortable: false,
        valueGetter: params => params.row.prevailingWageRate?.straightTimeTotalHourlyComp ?? null
      }),

      ...(isUnionLaborFeatureEnabled
        ? [
            currencyColumnDef({
              field: "unionStraightTimeWage",
              headerName: "Union Wage Rate",
              sortable: false,
              valueGetter: params => params.row.unionWageRate?.straightTimeWage ?? null
            }),
            currencyColumnDef({
              field: "unionStraightTimeFringe",
              headerName: "Union Fringe",
              sortable: false,
              valueGetter: params => {
                const u = params.row.unionWageRate;
                return u?.straightTimeTotalHourlyComp != null ? Number(u.straightTimeTotalHourlyComp) - Number(u.straightTimeWage || 0) : null;
              }
            }),
            dateColumnDef({
              field: "unionEffectiveDateEnd",
              headerName: "Union Wage Rate Expiration Date",
              sortable: false,
              valueGetter: params => params.row.unionWageRate?.effectiveDateEnd ?? null
            }),
            currencyColumnDef({
              field: "unionStraightTimeTotalHourlyComp",
              headerName: "Total Union Hourly Comp",
              sortable: false,
              valueGetter: params => params.row.unionWageRate?.straightTimeTotalHourlyComp ?? null
            })
          ]
        : []),

      percentageColumnDef({ field: "pwAiConfidenceMatchScore", headerName: "PW AI % Confidence Match Score" }),
      {
        field: "groupClassification",
        headerName: "Group Classification",
        renderCell: params => <Box>{params.row.groupClassification || "N/A"}</Box>
      },
      {
        field: "equipmentUsed",
        headerName: "Equipment Used",
        renderCell: params => <Box>{params.row.equipmentUsed || "N/A"}</Box>
      }
    ],
    projectJobsPermission.canDelete
  );

  const onEdit = () => {
    setFormConfig(changeMode("edit"));
    setPauseUpdate(false);
  };

  const handleReadValueClick = name => setFormConfig(changeModeForField(name, "edit"));

  const getAllProjectJobTitles = useCallback(async () => {
    setStatus(STAUTES.LOADING);
    const searchableFields = ["jobTitle", "externalJobTitle", "onetCode", "typeOfEquipment"];
    const safeSearchString = typeof searchString === "string" ? searchString : "";
    const query = createODataQuery(searchableFields, [], "", safeSearchString, sortModel, pageSize, currentPage);
    const { data, totalRecords, error } = await getApi(`${GET_ALL_PROJECT_JOB}${query}&projectId=${id}`);
    if (error) {
      setStatus(STAUTES.IDLE);
      return errorToast(error);
    }
    const finalData = Array.isArray(data) ? data : data?.data || [];
    const jobTitles = finalData.map((item, index) => ({
      ...item,
      ...(item.isExternalJobTitle ? { jobTitle: item.externalJobTitle } : {}),
      rowIndex: index
    }));
    setPageState(prev => ({
      ...prev,
      data: jobTitles,
      rowCount: totalRecords || finalData.length
    }));
    setStatus(STAUTES.IDLE);
  }, [currentPage, pageSize, sortModel, searchString, id, setPageState, setStatus]);

  const fetchJobTitles = async () => {
    const { data } = await postApi(GET_ALL_JOB_TITLE, defaultDropdownConfig);
    const descriptionMap = data?.reduce((acc, item) => {
      acc[item.jobTitleId] = item.jobTitleDescription;
      return acc;
    }, {});
    setJobTitleDescription(descriptionMap || {});
    setJobTitle(data?.map(item => ({ label: item.jobTitleName, value: item.jobTitleId })) || []);
  };

  const fetchAllAssignRAPDropDown = async () => {
    const { data } = await getApi(`${GET_ALL_ASSIGNRAPDROPDOWN}`);
    setAssignRAPInfoGuids(data?.map(item => ({ label: item.jobTitleName, value: item.assignRAPInfoId })).filter(item => item.label));
  };

  const fetchAllAssignRAPWageScaleDropDown = async rapInfoId => {
    const { data } = await getApi(`${GET_ALL_ASSIGNRAPWAGESCALEDROPDOWN}?rapInfoId=${rapInfoId}`);
    setAssignRAPWageScaleGuids(data?.map(item => ({ label: item?.wageScaleTitle, value: item?.assignRAPWageScaleId })));
  };

  const fetchAssignedRAPJobInfo = async rapInfoId => {
    const assignRAPInfo = await getApi(`${GET_ALL_ASSIGNRAPJOBINFO}/${rapInfoId}`);
    if (assignRAPInfo?.data) {
      setValue("onetCode", assignRAPInfo.data?.onetCode);
      setValue("occupationTitle", assignRAPInfo.data?.occupationTitle);
      setProjectJobData(data => ({ ...data, occupationTitle: assignRAPInfo.data?.occupationTitle }));
    }
  };

  const GetProjectWiseCountryAndState = async () => {
    const { data, error } = await getApi(`${GET_PROJECTWISE_COUNTRYANDSTATE}/${id}`);
    if (error) return errorToast(error);
    setWsPayload({ ...data, county: getCountyArray(data.county) });
    setIsFetchWsData(false);
    if (data.county && data.state) setIsCountyState(true);
  };

  const getCountyArray = counties => {
    if (counties) {
      return counties.includes(",") ? counties.split(",").map(county => county.trim()) : [counties.trim()];
    }
    return [];
  };

  const getJobSearchOption = async descriptions => {
    setValue("typeOfJob", []);
    setJobSearchOptions([]);
    clearErrors(["jobDescription"]);
    setClrInfoMessage(null);
    const descriptionWordLength = descriptions?.trim().split(/\s+/)?.length;
    if (descriptionWordLength > 1) {
      setIsFetchLabels(true);
      setIsNoRecordOnClassification(false);
      const body = {
        state: wsPayload?.state,
        county: wsPayload?.county,
        constructionType: constructionType,
        job_description: descriptions
      };
      try {
        const result = await axios.post(`${BASE_PWC_API_URL}get-job-names`, body, {
          headers: {
            Authorization: `Bearer ${BASE_WS_API_TOKEN}`
          }
        });
        setJobSearchOptions(result?.list_of_job_names || []);
        if (result?.list_of_job_names?.length === 1) {
          setValue("typeOfJob", result?.list_of_job_names);
        }
        if (result?.list_of_job_names?.length === 0) {
          setIsNoRecordOnClassification(true);
          setClrInfoMessage("No Labor Classification position found in SAM file. Please file CLR."); //or Initiate CLR
        }
        setIsFetchLabels(false);
      } catch (error) {
        console.log(error);
        setIsFetchLabels(false);
      }
    } else {
      setError("jobDescription", { type: "manual", message: "Please enter at least 2 words" });
    }
  };

  const getUnionFringeTotal = () => {
    return (
      Math.round(
        (parseFloat(unionStraightTimeFringeHealthAndWelfare || 0) +
          parseFloat(unionStraightTimeFringePension || 0) +
          parseFloat(unionStraightTimeFringeAnnuity || 0) +
          parseFloat(unionStraightTimeFringeApprenticeTraining || 0) +
          parseFloat(unionStraightTimeFringeVacation || 0) +
          parseFloat(unionStraightTimeFringeOther || 0)) *
          100
      ) / 100
    );
  };

  const getInvalidFringeCategories = values => {
    const categories = [
      { label: "H&W", value: values.unionStraightTimeFringeHealthAndWelfare },
      { label: "Pension", value: values.unionStraightTimeFringePension },
      { label: "Annuity", value: values.unionStraightTimeFringeAnnuity },
      { label: "Apprentice Training", value: values.unionStraightTimeFringeApprenticeTraining },
      { label: "Vacation/Sick", value: values.unionStraightTimeFringeVacation },
      { label: "Other", value: values.unionStraightTimeFringeOther }
    ];

    if (values.hasOTFringeOverride) {
      categories.push(
        { label: "Overtime H&W", value: values.unionOverTimeFringeHealthAndWelfare },
        { label: "Overtime Pension", value: values.unionOverTimeFringePension },
        { label: "Overtime Annuity", value: values.unionOverTimeFringeAnnuity },
        { label: "Overtime Apprentice Training", value: values.unionOverTimeFringeApprenticeTraining },
        { label: "Overtime Vacation/Sick", value: values.unionOverTimeFringeVacation },
        { label: "Overtime Other", value: values.unionOverTimeFringeOther }
      );
    }
    if (values.hasDTFringeOverride) {
      categories.push(
        { label: "Double-time H&W", value: values.unionDoubleTimeFringeHealthAndWelfare },
        { label: "Double-time Pension", value: values.unionDoubleTimeFringePension },
        { label: "Double-time Annuity", value: values.unionDoubleTimeFringeAnnuity },
        { label: "Double-time Apprentice Training", value: values.unionDoubleTimeFringeApprenticeTraining },
        { label: "Double-time Vacation/Sick", value: values.unionDoubleTimeFringeVacation },
        { label: "Double-time Other", value: values.unionDoubleTimeFringeOther }
      );
    }

    return categories
      .filter(({ value }) => value !== null && value !== undefined && String(value).trim() !== "")
      .filter(({ value }) => {
        const parsed = Number(value);
        // Fringe amounts may be 0 (a provided benefit with a $0 amount); only negative or
        // non-numeric values are invalid. The "override on => enter at least one OT/DT amount"
        // rule is enforced separately in submitJobSave (and by the API).
        return Number.isNaN(parsed) || parsed < 0;
      })
      .map(({ label }) => label);
  };

  const sumOverrideFringes = (overrides, straights) => {
    const total = overrides.reduce((acc, value, idx) => {
      const isOverridden = value !== null && value !== undefined && value !== "";
      const effective = isOverridden ? parseFloat(value || 0) : parseFloat(straights[idx] || 0);
      return acc + effective;
    }, 0);
    return Math.round(total * 100) / 100;
  };

  const straightFringes = [
    unionStraightTimeFringeHealthAndWelfare,
    unionStraightTimeFringePension,
    unionStraightTimeFringeAnnuity,
    unionStraightTimeFringeApprenticeTraining,
    unionStraightTimeFringeVacation,
    unionStraightTimeFringeOther
  ];

  const CheckDuplicateJobTitles = async () => {
    const data = await getApi(`${PROJECTS}/${id}/duplicateJobTitles`);
    setDuplicateJobTitles(data);
    setIsDuplicateJobTitles(data?.hasDuplicates || false);
  };

  const handleDuplicateJobTitlesPopup = () => {
    setIsDuplicateJobTitles(false);
  };

  const handleDeleteErrorPopup = () => {
    setIsDeleteError(false);
  };

  useEffect(() => {
    setIsFetchWsData(true);
    fetchJobTitles();
    fetchAllAssignRAPDropDown();
    GetProjectWiseCountryAndState();
  }, []);

  useEffect(() => {
    CheckDuplicateJobTitles();
  }, []);

  useEffect(() => {
    const type = watch("laborClassificationType");

    if (type === "craft") {
      setValue("IsCraftTradeLaborPosition", true);
      setValue("IsRole", false);
    } else if (type === "admin") {
      setValue("IsCraftTradeLaborPosition", false);
      setValue("IsRole", true);
    }
  }, [watch("laborClassificationType")]);

  useEffect(() => {
    getAllProjectJobTitles();
  }, [getAllProjectJobTitles]);

  useEffect(() => {
    setCalculatedValue(
      "prevailingStraightTimeTotalHourlyComp",
      (parseFloat(prevailingStraightTimeFringe || 0) + parseFloat(prevailingStraightTimeWage || 0)).toFixed(2)
    );
  }, [prevailingStraightTimeFringe, prevailingStraightTimeWage]);

  useEffect(() => {
    setCalculatedValue(
      "prevailingOverTimeTotalHourlyComp",
      (parseFloat(prevailingOverTimeWage || 0) + parseFloat(prevailingOverTimeFringe || 0)).toFixed(2)
    );
  }, [prevailingOverTimeWage, prevailingOverTimeFringe]);

  useEffect(() => {
    setCalculatedValue(
      "prevailingDoubleTimeTotalHourlyComp",
      (parseFloat(prevailingDoubleTimeWage || 0) + parseFloat(prevailingDoubleTimeFringe || 0)).toFixed(2)
    );
  }, [prevailingDoubleTimeWage, prevailingDoubleTimeFringe]);

  useEffect(() => {
    setCalculatedValue(
      "unionStraightTimeTotalHourlyComp",
      (parseFloat(unionStraightTimeFringe || 0) + parseFloat(unionStraightTimeWage || 0)).toFixed(2)
    );
  }, [unionStraightTimeWage, unionStraightTimeFringe]);

  useEffect(() => {
    clearErrors(["unionStraightTimeFringe"]);
    setCalculatedValue("unionStraightTimeFringe", getUnionFringeTotal().toFixed(2));
  }, [
    unionStraightTimeFringeHealthAndWelfare,
    unionStraightTimeFringePension,
    unionStraightTimeFringeAnnuity,
    unionStraightTimeFringeApprenticeTraining,
    unionStraightTimeFringeVacation,
    unionStraightTimeFringeOther
  ]);

  useEffect(() => {
    if (!hasOTFringeOverride) {
      const fallback = parseFloat(unionStraightTimeFringe || 0).toFixed(2);
      setCalculatedValue("unionOverTimeFringe", fallback);
      return;
    }
    const overrides = [
      unionOverTimeFringeHealthAndWelfare,
      unionOverTimeFringePension,
      unionOverTimeFringeAnnuity,
      unionOverTimeFringeApprenticeTraining,
      unionOverTimeFringeVacation,
      unionOverTimeFringeOther
    ];
    setCalculatedValue("unionOverTimeFringe", sumOverrideFringes(overrides, straightFringes).toFixed(2));
  }, [
    hasOTFringeOverride,
    unionStraightTimeFringe,
    unionOverTimeFringeHealthAndWelfare,
    unionOverTimeFringePension,
    unionOverTimeFringeAnnuity,
    unionOverTimeFringeApprenticeTraining,
    unionOverTimeFringeVacation,
    unionOverTimeFringeOther,
    unionStraightTimeFringeHealthAndWelfare,
    unionStraightTimeFringePension,
    unionStraightTimeFringeAnnuity,
    unionStraightTimeFringeApprenticeTraining,
    unionStraightTimeFringeVacation,
    unionStraightTimeFringeOther
  ]);

  useEffect(() => {
    setCalculatedValue("unionOverTimeTotalHourlyComp", (parseFloat(unionOverTimeWage || 0) + parseFloat(unionOverTimeFringe || 0)).toFixed(2));
  }, [unionOverTimeWage, unionOverTimeFringe]);

  useEffect(() => {
    if (!hasOTFringeOverride) {
      setValue("unionOverTimeFringeHealthAndWelfare", null);
      setValue("unionOverTimeFringePension", null);
      setValue("unionOverTimeFringeAnnuity", null);
      setValue("unionOverTimeFringeApprenticeTraining", null);
      setValue("unionOverTimeFringeVacation", null);
      setValue("unionOverTimeFringeOther", null);
      setOverrideErrors(prev => (prev.ot ? { ...prev, ot: false } : prev));
    }
  }, [hasOTFringeOverride]);

  useEffect(() => {
    if (!hasDTFringeOverride) {
      const fallback = parseFloat(unionStraightTimeFringe || 0).toFixed(2);
      setCalculatedValue("unionDoubleTimeFringe", fallback);
      return;
    }
    const overrides = [
      unionDoubleTimeFringeHealthAndWelfare,
      unionDoubleTimeFringePension,
      unionDoubleTimeFringeAnnuity,
      unionDoubleTimeFringeApprenticeTraining,
      unionDoubleTimeFringeVacation,
      unionDoubleTimeFringeOther
    ];
    setCalculatedValue("unionDoubleTimeFringe", sumOverrideFringes(overrides, straightFringes).toFixed(2));
  }, [
    hasDTFringeOverride,
    unionStraightTimeFringe,
    unionDoubleTimeFringeHealthAndWelfare,
    unionDoubleTimeFringePension,
    unionDoubleTimeFringeAnnuity,
    unionDoubleTimeFringeApprenticeTraining,
    unionDoubleTimeFringeVacation,
    unionDoubleTimeFringeOther,
    unionStraightTimeFringeHealthAndWelfare,
    unionStraightTimeFringePension,
    unionStraightTimeFringeAnnuity,
    unionStraightTimeFringeApprenticeTraining,
    unionStraightTimeFringeVacation,
    unionStraightTimeFringeOther
  ]);

  useEffect(() => {
    setCalculatedValue("unionDoubleTimeTotalHourlyComp", (parseFloat(unionDoubleTimeWage || 0) + parseFloat(unionDoubleTimeFringe || 0)).toFixed(2));
  }, [unionDoubleTimeWage, unionDoubleTimeFringe]);

  useEffect(() => {
    if (!hasDTFringeOverride) {
      setValue("unionDoubleTimeFringeHealthAndWelfare", null);
      setValue("unionDoubleTimeFringePension", null);
      setValue("unionDoubleTimeFringeAnnuity", null);
      setValue("unionDoubleTimeFringeApprenticeTraining", null);
      setValue("unionDoubleTimeFringeVacation", null);
      setValue("unionDoubleTimeFringeOther", null);
      setOverrideErrors(prev => (prev.dt ? { ...prev, dt: false } : prev));
    }
  }, [hasDTFringeOverride]);

  // Clear the red invalid styling reactively once the user fixes the override configuration.
  useEffect(() => {
    const hasPositive = vals => vals.some(v => v !== null && v !== undefined && v !== "" && parseFloat(v) > 0);
    const otValid =
      !hasOTFringeOverride ||
      hasPositive([
        unionOverTimeFringeHealthAndWelfare,
        unionOverTimeFringePension,
        unionOverTimeFringeAnnuity,
        unionOverTimeFringeApprenticeTraining,
        unionOverTimeFringeVacation,
        unionOverTimeFringeOther
      ]);
    const dtValid =
      !hasDTFringeOverride ||
      hasPositive([
        unionDoubleTimeFringeHealthAndWelfare,
        unionDoubleTimeFringePension,
        unionDoubleTimeFringeAnnuity,
        unionDoubleTimeFringeApprenticeTraining,
        unionDoubleTimeFringeVacation,
        unionDoubleTimeFringeOther
      ]);
    setOverrideErrors(prev => {
      const nextOt = prev.ot && !otValid;
      const nextDt = prev.dt && !dtValid;
      if (nextOt === prev.ot && nextDt === prev.dt) return prev;
      return { ot: nextOt, dt: nextDt };
    });
  }, [
    hasOTFringeOverride,
    hasDTFringeOverride,
    unionOverTimeFringeHealthAndWelfare,
    unionOverTimeFringePension,
    unionOverTimeFringeAnnuity,
    unionOverTimeFringeApprenticeTraining,
    unionOverTimeFringeVacation,
    unionOverTimeFringeOther,
    unionDoubleTimeFringeHealthAndWelfare,
    unionDoubleTimeFringePension,
    unionDoubleTimeFringeAnnuity,
    unionDoubleTimeFringeApprenticeTraining,
    unionDoubleTimeFringeVacation,
    unionDoubleTimeFringeOther
  ]);

  useEffect(() => {
    if (assignRAPInfoGuid) {
      fetchAllAssignRAPWageScaleDropDown(assignRAPInfoGuid);
      fetchAssignedRAPJobInfo(assignRAPInfoGuid);
    } else {
      setAssignRAPWageScaleGuids([]);
      setValue("assignRAPWageScaleGuid", null);
    }
  }, [assignRAPInfoGuid]);

  useEffect(() => {
    if (!pauseUpdate) {
      setValue("externalJobTitle", null);
      setValue("jobTitleId", null);
      setValue("typeOfJob", null);
      setValue("jobDescription", "");
    }
  }, [isExternalJobTitle]);

  useEffect(() => {
    if (!pauseUpdate && jobTitleId) {
      setValue("jobDescription", jobTitleDescription[jobTitleId]);
      getJobSearchOption(jobTitleDescription[jobTitleId]);
    }
  }, [jobTitleId]);

  const defaultFormProps = { control, formValues: projectJobData, handleReadValueClick };

  return (
    <>
      {!isCountyState && !showGrid && (
        <Box>
          <Alert
            severity="info"
            sx={{
              backgroundColor: theme.palette.projects.projectjobs.boxAlertBackground,
              color: theme.palette.projects.projectjobs.boxAlertColor,
              "& .MuiAlert-icon": {
                color: theme.palette.projects.projectjobs.alertIconColor
              },
              fontSize: "0.8rem"
            }}
          >
            The state and county fields are missing from your project. Kindly add them.
          </Alert>
        </Box>
      )}
      <TabGridAndFormLayout
        showGrid={showGrid}
        title={"Labor Classification Detail"}
        backLabel="Go back to Labor Classification Detail List"
        backAction={() => resetForm()}
        beingEdited={isEditModeOn}
        onEdit={onEdit}
        canView={jobListPermission.canView}
        hideEdit={!addJobPermisison.canEdit}
        onSave={handleSubmit(onSave)}
        onCancel={onCancel}
        isSaving={isSaving}
      >
        {showGrid && (
          <>
            <ProGrid
              title="Labor Classification Detail"
              columns={columns}
              showScrollbar={true}
              loading={status === STAUTES.LOADING}
              rows={jobData}
              searchMode={!!searchString}
              searchModel={{ defaultValue: searchString, handleDebounce: setSearchString }}
              addButtonLabel="+ Add Labor Classification Detail"
              addButtonAction={addButtonAction}
              hideAddButton={!jobListPermission.canAdd}
              hideExport={true}
              exportAction={handleDownloadCSV}
              additionButtons={
                <ProButton variant="outlined" onClick={handleDownloadCSV}>
                  Download as CSV
                </ProButton>
              }
              initialState={{
                pinnedColumns: {
                  left: ["jobTitle"]
                }
              }}
              options={{
                getRowId: row => row.projectJobTitleId || row.rowIndex || `${row.projectId}-${row.jobTitle}`,
                rowCount: rowCount,
                paginationMode: "server",
                paginationModel: { pageSize: pageSize, page: currentPage },
                onPaginationModelChange: setPagination,
                sortingMode: "server",
                onSortModelChange: setSortModel
              }}
            />
          </>
        )}
        {!showGrid && (
          <ProjectJobsPwc
            formConfig={formConfig}
            defaultFormProps={defaultFormProps}
            jobTitle={jobTitle}
            addJobPermisison={addJobPermisison}
            wsPayload={wsPayload}
            assignRAPInfoGuids={assignRAPInfoGuids}
            assignRAPWageScaleGuids={assignRAPWageScaleGuids}
            watch={watch}
            getValues={getValues}
            setValue={setValue}
            jobSearchOptions={jobSearchOptions}
            setWageRateConcented={setWageRateConcented}
            isEditModeOn={isEditModeOn}
            getPWCFilePath={getPWCFilePath}
            jobTitleDescription={jobTitleDescription}
            getJobSearchOption={() => getJobSearchOption(jobDescription)}
            isFetchLabels={isFetchLabels}
            trigger={trigger}
            setError={setError}
            clearErrors={clearErrors}
            isNoRecordOnClassification={isNoRecordOnClassification}
            clrInfoMessage={clrInfoMessage}
            onSaveClr={onSaveClr}
            closeCrlEmailModel={closeCrlEmailModel}
            onLowWageDetected={() => setShowWageDialog(true)}
            onApprenticeDataChange={setApprenticeData}
            setFinalApprenticeData={setFinalApprenticeData}
            overrideErrors={overrideErrors}
            isOTWageOverridden={isOTWageOverridden}
            isDTWageOverridden={isDTWageOverridden}
            isOTFringeOverridden={isOTFringeOverridden}
            isDTFringeOverridden={isDTFringeOverridden}
            setIsOTWageOverridden={setIsOTWageOverridden}
            setIsDTWageOverridden={setIsDTWageOverridden}
            setIsOTFringeOverridden={setIsOTFringeOverridden}
            setIsDTFringeOverridden={setIsDTFringeOverridden}
            isUnionOTWageOverridden={isUnionOTWageOverridden}
            isUnionDTWageOverridden={isUnionDTWageOverridden}
            setIsUnionOTWageOverridden={setIsUnionOTWageOverridden}
            setIsUnionDTWageOverridden={setIsUnionDTWageOverridden}
          />
        )}
      </TabGridAndFormLayout>
      <DialogModal
        show={isDuplicateJobTitles}
        title="Alert"
        message={duplicateJobTitles?.message}
        onConfirm={handleDuplicateJobTitlesPopup}
        showCancel={false}
        confirmBtnText={"Okay"}
      />
      <DialogModal
        show={isDeleteError}
        title="Alert"
        message={deleteErrorMessage}
        onConfirm={handleDeleteErrorPopup}
        showCancel={false}
        confirmBtnText={"Okay"}
      />
      <Dialog
        open={confirmLabourClassStatus.open}
        onClose={handleNoCancel}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="confirm-dialog-title">Confirm Status Change</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            Are you sure you want to change {confirmLabourClassStatus.labourClassification}'s status to {confirmLabourClassStatus.statusText}?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px" }}>
          <Button onClick={handleNoCancel} variant="outlined" color="primary" sx={{ minWidth: "120px" }}>
            No, Cancel
          </Button>
          <Button onClick={handleYesContinue} variant="contained" color="primary" autoFocus sx={{ minWidth: "120px" }}>
            Yes, Continue
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}